import { render, staticRenderFns } from "./FlaggedUsersClient.vue?vue&type=template&id=0d39f2a5&"
import script from "./FlaggedUsersClient.vue?vue&type=script&lang=js&"
export * from "./FlaggedUsersClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports